// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1E8Ka","right":"styles_right__1Ja94"};